<template>
  <div v-if="hasOtherList" class="my-5">
    <h4 v-if="hasVendorProducts" class="my-3">
      {{ $t(`message.spotlightV2.categories.${getSelectedSpotlightCategory()}.otherMessage`) }}
    </h4>
    <spotlight-product-list :product-list="otherProductList">
      <template v-slot="slotProps">
        <other-product-card
          :title="getProductTitle(slotProps.product)"
          :to="{ path: `${categoryBaseRoute}/${slotProps.product.internalName}` }"
          :category="getSelectedSpotlightCategory()"
        >
          <template v-slot:product-icon v-if="isAHighlight">
            <font-awesome-icon
              class="text-primary"
              :icon="['far', `${highlightsProductDataMap[slotProps.product.internalName].icon}`]"
              :style="{ marginLeft: '5px' }"
            ></font-awesome-icon>
          </template>
          <template v-slot:product-logo v-else-if="isVendor(slotProps.product)">
            <product-logo
              v-if="slotProps.product.internalName.includes('ia_')"
              :name="`ia_dealer_services_${$i18n.locale}`"
              list="productList"
            />
            <product-logo
              v-else-if="slotProps.product.internalName.includes('auto-shield_')"
              :name="`auto-shield_logo`"
              list="productList"
            />
            <product-logo
              v-else-if="slotProps.product.internalName.includes('global-warranty_')"
              :name="`global-warranty_logo`"
              list="productList"
            />
            <product-logo v-else :name="slotProps.product.internalName" list="otherProductList" />
          </template>
        </other-product-card>
      </template>
    </spotlight-product-list>
  </div>
</template>

<script>
import { spotlightMixin } from '@/mixins';

const SpotlightProductList = () => import('@/modules/spotlight/components/SpotlightProductList.vue');
const OtherProductCard = () => import('@/modules/spotlight/components/OtherProductCard.vue');
const ProductLogo = () => import('@/modules/spotlight/containers/ProductLogo.vue');

export default {
  name: 'OtherProducts',
  mixins: [spotlightMixin],
  components: {
    SpotlightProductList,
    OtherProductCard,
    ProductLogo,
  },
  computed: {
    isAHighlight() {
      return this.getSelectedSpotlightCategory() === this.enums.SpotlightConstants.categories.HIGHLIGHTS;
    },
    otherProductList() {
      return this.getProductList(this.getSelectedSpotlightCategory()).filter(product => {
        // Filter out Autoverify products if currently selected product is not an AutoVerify product
        if (!this.$route.path.includes('autoverify_')) {
          return !this.$route.path.includes(product.internalName) && !product.internalName.includes('autoverify_');
        }

        // Filter out the currently selected product
        return !this.$route.path.includes(product.internalName);
      });
    },
    hasOtherList() {
      return this.otherProductList.length > 0;
    },
    hasVendorProducts() {
      return this.otherProductList.some(product => !product.internalName.includes('autoverify_'));
    },
    highlightsProductDataMap() {
      return {
        [this.enums.SpotlightConstants.internalNames.siriusXm['VEHICLE-PROGRAM']]: {
          icon: 'volume',
        },
        [this.enums.SpotlightConstants.internalNames.autoverify['LOW-MILEAGE']]: {
          icon: 'tachometer-slow',
        },
        [this.enums.SpotlightConstants.internalNames.autoverify['NEW-LISTING']]: {
          icon: 'stars',
        },
        [this.enums.SpotlightConstants.internalNames.autoverify['PRICE-REDUCTION']]: {
          icon: 'arrow-alt-circle-down',
        },
        [this.enums.SpotlightConstants.internalNames.autoverify['HIGH-SAFETY-RATING']]: {
          icon: 'shield-check',
        },
        [this.enums.SpotlightConstants.internalNames.autoverify['GETTING-NOTICED']]: {
          icon: 'fire',
        },
        [this.enums.SpotlightConstants.internalNames.autoverify['GREAT-DEAL']]: {
          icon: 'badge-dollar',
        },
      };
    },
  },
  methods: {
    getProductTitle(product) {
      return this.getProductContent(product).title;
    },
  },
};
</script>

<style scoped></style>
